import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import SitemarkIcon from './SitemarkIcon';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {`Copyright © Purple Axolotls ${new Date().getFullYear()}`}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        py: { xs: 8, sm: 10 },
      }}
    >
      <SitemarkIcon />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Link
          variant="body2"
          href="#"
          sx={{
            color: 'text.secondary',
          }}
        >
          Privacy Policy
        </Link>
        <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
          &nbsp;•&nbsp;
        </Typography>
        <Link
          variant="body2"
          href="#"
          sx={{
            color: 'text.secondary',
          }}
        >
          Terms of Service
        </Link>
      </Box>
      <Copyright />
    </Container>
  );
}
